export default __webpack_public_path__ + "static/media/HOLD 2.74ef2a2a.mp3";